import { createUseStyles, useTheme } from 'react-jss';

import { QuestionAnswer, TitleWithIcon } from 'components';
import { Theme } from '@app/theme';

import {
  useParticipant,
  useParticipantFieldsByCategory,
  useParticipantFieldsCategories,
} from '@app/api';
import { useGetParticipantDisplayValue } from '@app/participant-fields';
import { ParticipantProfileDetailsTags } from './ParticipantProfileDetailsTags';

interface Props {
  participantId: string;
  sessionId: string;
}

const useStyles = createUseStyles((theme: Theme) => ({
  marginTop: {
    marginTop: theme.marginBase * 5,
  },
}));

export const ParticipantProfileDetails = ({ participantId }: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });

  const { data: participant } = useParticipant(participantId);

  const participantFields = useParticipantFieldsByCategory();
  const { data: categories = [] } = useParticipantFieldsCategories();
  const getParticipantDisplayValue = useGetParticipantDisplayValue();

  return (
    <>
      {categories.map((category) => (
        <>
          <TitleWithIcon
            iconColor={category.iconColor}
            icon={category.icon}
            className={classes.marginTop}
            title={category.titleClient || category.title}
            key={category.name}
          />
          {participant &&
            participantFields[category.name] &&
            participantFields[category.name].map((field) =>
              field.name === 'tags' ? (
                <ParticipantProfileDetailsTags participant={participant} />
              ) : (
                (!field.profile || !field.profile.hidden) && (
                  <QuestionAnswer
                    question={field.label}
                    answer={
                      getParticipantDisplayValue(participant, field) || '-'
                    }
                    key={field.name}
                  />
                )
              ),
            )}
        </>
      ))}
    </>
  );
};
